/**
 * Calculates the squared length of a quat
 *
 * @param {quat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */
module.exports = require('gl-vec4/squaredLength')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/squaredLength.js
// module id = 1351
// module chunks = 0